import React, { useState, useEffect } from "react";
import "./index.scss";
import Translation from "components/common/translations";
import AuthController from "controllers/authController";
import { toast } from "react-toastify";
import ShowConfirmCode from "../showConfirmCode";
import { useNavigate } from "react-router-dom";
import ForgotPassword from "pages/forgotPassword";

export default function LoginPopup({ setVisible }) {
  const [userData, setUserData] = useState({ email: "", password: "" });
  const [modalStates, setModalStates] = useState({
    confirmEmail: false,
    forgotPassword: false,
  });
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    };
  }, []);

  const openConfirmCode = (email) =>
    setModalStates({ ...modalStates, confirmEmail: true, email: email });

  const closeConfirmCode = () =>
    setModalStates({ ...modalStates, confirmEmail: false });

  const openForgotPassword = () =>
    setModalStates({ ...modalStates, forgotPassword: true });

  const closeForgotPassword = () =>
    setModalStates({ ...modalStates, forgotPassword: false });

  const openRegistration = async () => {
    try {
      await AuthController.localLogoutNavReg();
      navigate("/register");
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error("An error occurred while logging out.");
    }
  };

  const handleChange = (id) => (e) =>
    setUserData({ ...userData, [id]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = userData;

    if (!email || !password) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const loginResponse = await AuthController.login(email, password);

      if (loginResponse && loginResponse.email) {
        openConfirmCode(loginResponse.email);
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const { email, password } = userData;

  return (
    <>
      {modalStates.confirmEmail && (
        <ShowConfirmCode
          email={modalStates.email}
          onClose={closeConfirmCode}
          isExpired={true}
          setVisible={setVisible}
        />
      )}
      {modalStates.forgotPassword && (
        <>
          <div className="dim-overlay"></div>
          <ForgotPassword onClose={closeForgotPassword} />
        </>
      )}

      <div className="login-popup-container">
        <div className="login-popup-content">
          <div className="d-flex justify-center">
            <h2 className="h2-login">
              <Translation label={"_loginTitle"} />
            </h2>
          </div>

          <div className="mt-20">
            <form onSubmit={handleSubmit}>
              <input
                value={email}
                type="text"
                onChange={handleChange("email")}
                className="inputs-login"
                placeholder={Translation({ label: "_logEnterYourEmail" })}
                required
              ></input>
              <input
                value={password}
                type="password"
                onChange={handleChange("password")}
                className="inputs-login"
                placeholder={Translation({ label: "_logEnterYourPassword" })}
                required
                onKeyDown={handleKeyPress}
              ></input>
              <button type="submit" className="button-login">
                <Translation label={"_loginButton"} />
              </button>
            </form>

            <div className="div-forgotpass">
              <button
                onClick={openForgotPassword}
                className="button-forgotpass"
              >
                <Translation label={"_forgotPassword"} />
              </button>
            </div>

            <button onClick={openRegistration} className="button-createnewacc">
              <Translation label={"_createNewAccaountButton"} />
            </button>
          </div>
        </div>
        <div className="loginPopup-dim-overlay"></div>
      </div>
    </>
  );
}
